import HandleClient, { HandleClientContext, KoraLabsProvider } from "@koralabs/adahandle-sdk";
import { useMemo } from "react";
import { getEnv } from "../utils/network.utils";

export const useHandleClient = () => {
  const network = getEnv();
  const context = network === "mainnet" ? HandleClientContext.MAINNET : HandleClientContext.PREVIEW;
  const provider = new KoraLabsProvider(context);
  const client = useMemo(
    () =>
      new HandleClient({
        context,
        provider,
      }),
    [context, provider]
  );

  return client;
};
